module.exports = __webpack_public_path__ + "h5/img/home-box4-left.36c20350.png";